import { Reveal } from "./Reveal";
import { NOSOTROS } from "./data";
import { useNosotros } from "@/lib/useContent";
import { History, MapPin, Heart, Building2, ArrowRight } from "lucide-react";

const ICONS = { history: History, field: MapPin, fans: Heart, infra: Building2 };

export const Nosotros = () => {
  const data = useNosotros(NOSOTROS);
  return (
    <section id="club" className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="absolute -top-32 -right-24 h-80 w-80 rounded-full bg-gold/5 blur-3xl" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="section-tag">Conocé el club</span>
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy leading-[1.1]">
              Una historia hecha<br className="hidden sm:block" /> de pasión y comunidad
            </h2>
            <p className="mt-6 text-lg text-gray-600 leading-relaxed">{data.lead}</p>
            {data.image_url && (
              <div className="mt-7 rounded-2xl overflow-hidden border border-gray-100 shadow-md">
                <img src={data.image_url} alt="El club" loading="lazy" className="w-full h-56 object-cover" />
              </div>
            )}
            <button
              data-testid="nosotros-cta"
              onClick={() => document.getElementById("historia")?.scrollIntoView({ behavior: "smooth" })}
              className="mt-8 inline-flex items-center gap-2 text-navy font-bold hover:gap-3 transition-all"
            >
              Ver nuestra historia completa <ArrowRight className="h-5 w-5" />
            </button>
          </Reveal>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {data.blocks.map((b, i) => {
              const Icon = ICONS[b.icon] || History;
              return (
                <Reveal key={b.title} delay={i * 0.08}>
                  <div className="group h-full bg-[#eef1f7] rounded-2xl border border-gray-100 p-7 hover:bg-navy hover:-translate-y-1 transition-all duration-300">
                    <div className="h-12 w-12 rounded-xl bg-navy group-hover:bg-gold flex items-center justify-center transition-colors">
                      <Icon className="h-6 w-6 text-gold group-hover:text-navy transition-colors" />
                    </div>
                    <h3 className="mt-5 text-xl font-semibold text-navy group-hover:text-white transition-colors">{b.title}</h3>
                    <p className="mt-2.5 text-gray-600 group-hover:text-white/80 leading-relaxed transition-colors">{b.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
